import moment from "moment"
import React from "react"
import PropTypes from "prop-types"
import { DateInput } from "@mantine/dates"

const DatePickerFilter = (props) => {
    const handleDateChange = (date) => {
        props.publishChange(date)
    }

    return (
        <DateInput
            aria-label={props.displayLabel}
            clearable
            firstDayOfWeek={0} // Sunday
            minDate={props.minDate instanceof Date ? props.minDate : null}
            maxDate={props.noFuture ? new Date() : null}
            onChange={handleDateChange}
            placeholder="mm/dd/yyyy"
            value={(props.value && moment(props.value).toDate()) || null}
            valueFormat="MM/DD/YYYY"
        />
    )
}

DatePickerFilter.propTypes = {
    deserializedValue: PropTypes.object,
    minDate: PropTypes.string,
    noFuture: PropTypes.bool,
    publishChange: PropTypes.func.isRequired,
}

export default DatePickerFilter
